import joint from "rappid";
import _ from "lodash";

const V = joint.V;
const g = joint.g;

const ModuleAttrs = {
	SocialNetwork: {
		name: "Web 2.0 Blogs",
		backgroundColor: "#3b5998",
		textColor: "#f6f6f6"
	},
	WebProfile: {
		name: "Web 2.0 Profile",
		backgroundColor: "#feb663",
		textColor: "#222138"
	},
	Bookmarking: {
		name: "Boomarking",
		backgroundColor: "#b75d32",
		textColor: "#f6f6f6"
	},
	Wiki: {
		name: "Wiki",
		backgroundColor: "#dcd7d7",
		textColor: "#222138"
	},
	ArticleDirectory: {
		name: "Article Directory",
		backgroundColor: "#eb4924",
		textColor: "#f6f6f6"
	},
	PDF: {
		name: "PDF",
		backgroundColor: "#7c68fc",
		textColor: "#f6f6f6"
	},
	ForumProfile: {
		name: "Forum Profile",
		backgroundColor: "transparent",
		textColor: "#222138"
	},
	PressRelease: {
		name: "Press Release",
		backgroundColor: "#31d0c6",
		textColor: "#222138"
	}
};

joint.dia.Element.define(
	"rankerx.Project",
	{
		size: {
			width: 150,
			height: 100
		},
		moduleHeight: 20,
		headerHeight: 20,
		moduleName: "Project",
		attrs: {
			".body": {
				refWidth: "100%",
				refHeight: "100%",
				strokeWidth: 2,
				stroke: "#3e9c35",
				fill: "transparent"
			},
			".header": {
				refWidth: "100%",
				height: 20,
				strokeWidth: 2,
				stroke: "#3e9c35",
				fill: "transparent"
			},
			".moduleCheckbox": {
				refX: 2
			},
			".moduleBackground": {
				refWidth: "100%",
				height: 20,
				refX: 0,
				strokeWidth: 2
				// stroke: "#3b5998",
				// fill: "#3b5998"
			},
			".moduleText": {
				textVerticalAnchor: "middle",
				textAnchor: "middle",
				refX: "10",
				refX2: "50%",
				refY: 12,
				fontFamily: "sans-serif, Arial",
				fontWeight: "Bold",
				fontSize: 12,
				strokeWidth: 0,
				fill: "#f6f6f6"
			},
			".headerText": {
				textVerticalAnchor: "middle",
				textAnchor: "middle",
				refX: "50%",
				refY: 12,
				fontFamily: "sans-serif, Arial",
				fontWeight: "Bold",
				fontSize: 12,
				strokeWidth: 0,
				fill: "#222138"
			},
			bodyText: {
				textVerticalAnchor: "middle",
				textAnchor: "middle",
				refX: "50%",
				refY: "50%",
				refY2: 15,
				fontSize: 14,
				fill: "#333333"
			}
		}
	},
	{
		markup: `<rect class="body" /><rect class="header" /><text class="headerText"></text><g class="modules"></g>`,
		moduleMarkup: `<g class="module"><rect class="moduleBackground" /><text class="moduleText"></text></g>`,
		moduleCheckMarkup: `<g class="moduleCheckbox" >
				<rect width="20" height="20" class="love" fill="transparent" cursor="pointer" />				
				<path d="M12.38384375,8.03428125c-0.035625,-0.01796875,-0.0713125,-0.0269375,-0.10728125,-0.0269375c-0.0774375,0,-0.14565625,0.02971875,-0.20509375,0.08928125l-0.5710625,0.57096875c-0.053375,0.05359375,-0.0801875,0.1189375,-0.0801875,0.19634375v2.26603125c0,0.39265625,-0.13946875,0.7285625,-0.41921875,1.00825c-0.27953125,0.27953125,-0.61565625,0.4193125,-1.00825,0.4193125H2.5695625c-0.392625,0,-0.72871875,-0.13978125,-1.00825,-0.4193125c-0.27959375,-0.27965625,-0.4193125,-0.6155625,-0.4193125,-1.00825V3.7069375c0,-0.3925625,0.13971875,-0.728625,0.4193125,-1.00825c0.27953125,-0.2795625,0.615625,-0.4193125,1.00825,-0.4193125H9.9928125c0.130875,0,0.2646875,0.01784375,0.40146875,0.0535625c0.03571875,0.0118125,0.06246875,0.01784375,0.08009375,0.01784375c0.0774375,0,0.145875,-0.02965625,0.2053125,-0.089125l0.4371875,-0.4371875c0.0713125,-0.07128125,0.0981875,-0.15759375,0.0801875,-0.258625c-0.01784375,-0.0951875,-0.0714375,-0.163625,-0.16065625,-0.20521875c-0.321,-0.1485,-0.669125,-0.22309375,-1.04384375,-0.22309375H2.5695625c-0.7078125,0,-1.3130625,0.2513125,-1.8156875,0.7539375C0.2513125,2.39415625,0,2.9993125,0,3.70715625v7.42321875c0,0.70771875,0.2513125,1.3129375,0.75390625,1.8155625c0.502625,0.50275,1.107875,0.7540625,1.8156875,0.7540625h7.42315625c0.70771875,0,1.31303125,-0.2513125,1.81565625,-0.7540625c0.50265625,-0.502625,0.7541875,-1.1078125,0.7541875,-1.8155625v-2.83740625C12.56253125,8.16815625,12.50275,8.08196875,12.38384375,8.03428125z"/>
				<path d="M14.6234375,2.913l-0.98153125,-0.98153125c-0.14275,-0.14271875,-0.312375,-0.21409375,-0.50871875,-0.21409375c-0.19609375,0,-0.36584375,0.071375,-0.50846875,0.21409375L6.85203125,7.704125l-2.346375,-2.34653125c-0.14278125,-0.1428125,-0.31234375,-0.21409375,-0.5085625,-0.21409375c-0.19625,0,-0.36575,0.07128125,-0.5085625,0.21409375l-0.98140625,0.98140625c-0.14275,0.14275,-0.2141875,0.3123125,-0.2141875,0.50865625c0,0.19625,0.0714375,0.36575,0.2141875,0.5085625l3.83646875,3.83646875c0.14278125,0.14284375,0.31234375,0.21409375,0.5085625,0.21409375c0.19621875,0,0.36575,-0.07121875,0.5085625,-0.21409375l7.262625,-7.26259375c0.14265625,-0.14271875,0.2141875,-0.3123125,0.2141875,-0.5085625S14.7661875,3.05571875,14.6234375,2.913z" />			
			</g>`,
		moduleUncheckMarkup: `<g class="moduleCheckbox" >
				<rect width="20" height="20" class="love" fill="transparent" cursor="pointer" />	
				<path fill="#FFFFFF" d="M11.8084375,0.7539375C11.3058125,0.2513125,10.70053125,0,9.99278125,0H2.56959375C1.86184375,0,1.25659375,0.2513125,0.75390625,0.7539375C0.251375,1.256625,0.0000625,1.86175,0.0000625,2.569625v7.42321875c0,0.70771875,0.2513125,1.3129375,0.75384375,1.81565625c0.5026875,0.50265625,1.1079375,0.75396875,1.8156875,0.75396875h7.4231875c0.70775,0,1.31284375,-0.2513125,1.8156875,-0.75396875c0.50265625,-0.50271875,0.7539375,-1.10790625,0.7539375,-1.81565625V2.569625C12.56228125,1.861875,12.31096875,1.256625,11.8084375,0.7539375zM11.42025,9.99284375c0,0.39246875,-0.1396875,0.7285625,-0.41921875,1.00825c-0.27953125,0.27953125,-0.6155625,0.41909375,-1.00828125,0.41909375H2.56959375c-0.39259375,0,-0.72865625,-0.1395625,-1.00825,-0.41909375c-0.27953125,-0.27965625,-0.4193125,-0.61578125,-0.4193125,-1.00825V2.569625c0,-0.3925625,0.13978125,-0.728625,0.4193125,-1.00825c0.27959375,-0.2795625,0.61565625,-0.4193125,1.00825,-0.4193125h7.4231875c0.3926875,0,0.72871875,0.13978125,1.00828125,0.4193125c0.27953125,0.27959375,0.41921875,0.61565625,0.41921875,1.00825V9.99284375L11.42025,9.99284375z"/>
			</g>`,
		initialize: function() {
			joint.dia.Element.prototype.initialize.apply(this, arguments);
			this.on(
				"change:modules",
				() => {
					console.log("modules changed");
				},
				this
			);
			this.attr(".headerText/text", this.get("moduleName"), { silent: true });
			this.onChangeModules();
		},
		testChangeModules: function() {
			// console.log("Vao day roi");
		},
		addModules: function(newModules) {
			var modules = this.get("modules");
			if (modules == null) {
				modules = [];
			}
			modules = modules.concat(newModules);
			this.set("modules", modules, { silent: true });
			this.onChangeModules();
		},
		onChangeModules: function() {
			var modules = this.get("modules");
			var moduleHeight = this.get("moduleHeight");
			var headerHeight = this.get("headerHeight");
			var attrs = this.get("attrs");
			_.each(attrs, (attrs, selector) => {
				if (attrs.dynamic) {
					// Remove silently because we're going to update `attrs`
					// later in this method anyway.
					this.removeAttr(selector, { silent: true });
				}
			});
			var offsetY = headerHeight + 2;
			var attrsUpdate = {};
			var moduleHeight = this.get("moduleHeight");

			_.each(
				modules,
				function(module) {
					var selector = ".module-check-" + module.id;

					if (module.checked) {
						attrsUpdate[selector] = {
							transform: "translate(0, " + (offsetY + 3) + ")",
							height: moduleHeight,
							dynamic: true
						};
					} else {
						attrsUpdate[selector] = {
							transform: "translate(0, " + (offsetY + 4) + ")",
							height: moduleHeight,
							dynamic: true
						};
					}

					attrsUpdate[selector + " path"] = {
						fill: ModuleAttrs[module.id].textColor,
						dynamic: true
					};

					selector = ".module-" + module.id;

					attrsUpdate[selector] = {
						transform: "translate(0, " + offsetY + ")",
						height: moduleHeight,
						fill: ModuleAttrs[module.id].backgroundColor,
						stroke: ModuleAttrs[module.id].backgroundColor,
						dynamic: true
					};
					attrsUpdate[selector + " .moduleText"] = {
						text: ModuleAttrs[module.id].name,
						fill: ModuleAttrs[module.id].textColor
					};
					// attrsUpdate[selector + ' .option-rect'] = { height: optionHeight, dynamic: true };
					// attrsUpdate[selector + ' .option-text'] = { text: option.text, dynamic: true, refY: optionHeight / 2 };

					offsetY += moduleHeight + 2;
				},
				this
			);

			this.attr(attrsUpdate);
			this.autoresize();
		},
		autoresize: function() {
			let modules = this.get("modules");
			if (modules != null) {
				let moduleHeight = this.get("moduleHeight");
				let headerHeight = this.get("headerHeight");
				let width = this.get("size").width;
				let height = modules.length * (moduleHeight + 2) + headerHeight + 1;
				this.resize(Math.max(width, 150), height);
			}
		},
		changeModules: function() {
			var modules = JSON.parse(JSON.stringify(this.get("modules")));
			this.set("modules", modules);
			console.log(this.get("modules"));
		}
	}
); //

joint.shapes.rankerx.ProjectView = joint.dia.ElementView.extend({
	events: {
		"click .moduleCheckbox": "onSelectModule"
		// "click .love": "onLoveClick"
	},
	initialize: function() {
		joint.dia.ElementView.prototype.initialize.apply(this, arguments);
		// this.listenTo(this.model, 'change:options', this.renderOptions, this);
	},
	renderMarkup: function() {
		joint.dia.ElementView.prototype.renderMarkup.apply(this, arguments);

		// A holder for all the options.
		this.$modules = this.$(".modules");
		// Create an SVG element representing one option. This element will
		// be cloned in order to create more options.
		this.elModule = V(this.model.moduleMarkup);
		this.elModuleCheck = V(this.model.moduleCheckMarkup);
		this.elModuleUncheck = V(this.model.moduleUncheckMarkup);

		this.renderModules();
	},

	renderModules: function() {
		this.$modules.empty();

		_.each(this.model.get("modules"), (module, index) => {
			var className = "module-" + module.id;
			var elModule = this.elModule.clone().addClass(className);
			elModule.attr("module-id", module.id);
			this.$modules.append(elModule.node);

			if (module.checked) {
				className = "module-check-" + module.id;
				var elModuleCheck = this.elModuleCheck.clone().addClass(className);
				elModuleCheck.attr("module-id", module.id);
				this.$modules.append(elModuleCheck.node);
			} else {
				className = "module-check-" + module.id;
				var elModuleUncheck = this.elModuleUncheck.clone().addClass(className);
				elModuleUncheck.attr("module-id", module.id);
				this.$modules.append(elModuleUncheck.node);
			}
		});

		// Apply `attrs` to the newly created SVG elements.
		this.update();
	},
	onSelectModule: function(evt) {
		let moduleId = V(evt.target.parentNode).attr("module-id");
		let modules = this.model.get("modules");
		let foundIndex = modules.findIndex(module => module.id == moduleId);
		// modules.splice(foundIndex, 1);
		// this.model.changeModules();
		if (foundIndex != -1) {
			let module = modules[foundIndex];
			module.checked = !module.checked;
			this.model.onChangeModules();
			this.renderModules();
		}
	}
});

joint.shapes.standard.HeaderedRectangle.define("rankerx.MoneySite", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#3e9c35",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#3e9c35",
			fill: "#3e9c35",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		web20: {
			stroke: "#3b5998",
			fill: "#3b5998",
			strokeWidth: 2,
			strokeDasharray: "0"
			// height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 12,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Money Site",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 12,
			strokeWidth: 0,
			refY: 12,
			nameId: 0			
		},
		custom: {
			projectName: "",
			profileName: ""
		}		
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.SocialNetwork", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#3b5998",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#3b5998",
			fill: "#3b5998",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Web 2.0 Blog",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.SocialNetworkPremium", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1"
		},
		header: {			
			fill: "#3b5998",
			stroke: "red",			
			strokeWidth: 3,
			strokeDasharray: "4 1",
			height: 30
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 14
		},
		headerText: {
			text: "Web 2.0 Blog\nPremium",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 15,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.WebProfile", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#feb663",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#feb663",
			fill: "#feb663",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Web 2.0 Profile",
			fill: "#222138",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.WebProfilePremium", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1"
		},
		header: {
			stroke: "#feb663",
			fill: "#feb663",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1",
			height: 30
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Web 2.0 Profile\nPremium",
			fill: "#222138",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 15,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.Bookmarking", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#b75d32",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#b75d32",
			fill: "#b75d32",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Bookmarking",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.BookmarkingPremium", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1"
		},
		header: {
			stroke: "#b75d32",
			fill: "#b75d32",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1",
			height: 30
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Bookmarking\nPremium",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 15,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.PDFPremium", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "red",			
			strokeWidth: 3,
			strokeDasharray: "4 1"
		},
		header: {
			stroke: "#7c68fc",
			fill: "#7c68fc",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1",
			height: 30
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "PDF\nPremium",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 15,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.ForumProfile", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#eb4924",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#eb4924",
			fill: "transparent",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Forum Profile",
			fill: "#222138",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.PressReleasePremium", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1"
		},
		header: {
			stroke: "#31d0c6",
			fill: "#31d0c6",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1",
			height: 30
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Press Release",
			fill: "#222138",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 15,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}		
	}
});

joint.shapes.standard.HeaderedRectangle.define("rankerx.Wiki", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#dcd7d7",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#dcd7d7",
			fill: "#dcd7d7",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Wiki",
			fill: "#222138",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""			
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //
joint.shapes.standard.HeaderedRectangle.define("rankerx.ArticleDirectory", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#eb4924",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#eb4924",
			fill: "#eb4924",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Article Directory",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.ArticleDirectoryPremium", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1"
		},
		header: {
			stroke: "#eb4924",
			fill: "#eb4924",
			stroke: "red",
			strokeWidth: 3,
			strokeDasharray: "4 1",
			height: 30
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Article Directory\nPremium",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 15,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
}); //

joint.shapes.standard.HeaderedRectangle.define("rankerx.Private", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#222138",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#222138",
			fill: "#222138",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Private Blog",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
});
joint.shapes.standard.HeaderedRectangle.define("rankerx.PrivateBookmark", {
	attrs: {
		body: {
			fill: "transparent",
			stroke: "#222138",
			strokeWidth: 2,
			strokeDasharray: "0"
		},
		header: {
			stroke: "#222138",
			fill: "#222138",
			strokeWidth: 2,
			strokeDasharray: "0",
			height: 20
		},
		bodyText: {
			text: "",
			fill: "#222138",
			fontFamily: "Roboto Condensed",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY2: 12
		},
		headerText: {
			text: "Private Bookmark",
			fill: "#f6f6f6",
			fontFamily: "sans-serif, Arial",
			fontWeight: "Bold",
			fontSize: 11,
			strokeWidth: 0,
			refY: 12,
			nameId: 0,
			profileName: ""
		},
		custom: {
			projectName: "",
			profileName: ""
		}
	}
});

joint.shapes.standard.Link.define(
	"app.Link",
	{
		// router: {
		// 	name: "manhattan"
		// },
		connector: {
			name: "rounded"
		},
		labels: [],
		attrs: {
			line: {
				stroke: "#8f8f8f",
				strokeDasharray: "0",
				strokeWidth: 2,
				fill: "none",
				sourceMarker: {
					type: "path",
					d: "M 0 -5 -10 0 0 5 z",
					stroke: "none"
				},
				targetMarker: {
					type: "path",
					d: "M 0 0 0 0",
					stroke: "none"
				}
			}
		}
	},
	{
		defaultLabel: {
			attrs: {
				rect: {
					fill: "#ffffff",
					stroke: "#8f8f8f",
					strokeWidth: 1,
					refWidth: 10,
					refHeight: 10,
					refX: -5,
					refY: -5
				}
			}
		},

		getMarkerWidth: function(type) {
			var d =
				type === "source"
					? this.attr("line/sourceMarker/d")
					: this.attr("line/targetMarker/d");
			return this.getDataWidth(d);
		},

		getDataWidth: _.memoize(function(d) {
			return new g.Path(d).bbox().width;
		})
	},
	{
		connectionPoint: function(line, view, magnet, opt, type, linkView) {
			var markerWidth = linkView.model.getMarkerWidth(type);
			opt = { offset: markerWidth, stroke: true };
			// connection point for UML shapes lies on the root group containg all the shapes components
			if (view.model.get("type").indexOf("uml") === 0) opt.selector = "root";
			return joint.connectionPoints.boundary.call(
				this,
				line,
				view,
				magnet,
				opt,
				type,
				linkView
			);
		}
	}
);

// Navigator Views

joint.shapes.app.NavigatorElementView = joint.dia.ElementView.extend({
	rect: null,

	initialize: function() {
		this.listenTo(this.model, "change:position", this.translate);
		this.listenTo(this.model, "change:size", this.resize);
		this.listenTo(this.model, "change:angle", this.rotate);
	},

	render: function() {
		this.rect = V("rect", { fill: "#31d0c6" }).appendTo(this.el);
		this.update();
	},

	update: function() {
		this.rect.attr(this.model.get("size"));
		this.updateTransformation();
	}
});

joint.shapes.app.NavigatorLinkView = joint.dia.LinkView.extend({
	initialize: function() {},

	render: function() {},

	update: function() {}
});

joint.util.measureText = function(text, attrs) {

    var fontSize = parseInt(attrs.fontSize, 10) || 10;

    var svgDocument = V('svg').node;
    var textElement = V('<text><tspan></tspan></text>').node;
    var textSpan = textElement.firstChild;
    var textNode = document.createTextNode('');

    textSpan.appendChild(textNode);
    svgDocument.appendChild(textElement);
    document.body.appendChild(svgDocument);

    var lines = text.split('\n');
    var width = 0;

    // Find the longest line width.
    _.each(lines, function(line) {

        textNode.data = line;
        var lineWidth = textSpan.getComputedTextLength();

        width = Math.max(width, lineWidth);
    });

    var height = lines.length * (fontSize * 1.2);

    V(svgDocument).remove();

    return { width: width, height: height };
};
